import { render, staticRenderFns } from "./GdprPopup.vue?vue&type=template&id=6fcb84a8&scoped=true&"
import script from "./GdprPopup.vue?vue&type=script&lang=js&"
export * from "./GdprPopup.vue?vue&type=script&lang=js&"
import style0 from "./GdprPopup.vue?vue&type=style&index=0&id=6fcb84a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb84a8",
  null
  
)

export default component.exports